@if (visible()) {
  <div
    role="region"
    aria-label="Aviso sobre cookies"
    class="fixed inset-x-0 bottom-0 z-[100000] border-t border-gray-200 bg-white p-4 shadow-[0_-4px_24px_rgba(0,0,0,0.08)] md:p-5"
  >
    <div class="mx-auto flex max-w-5xl flex-col gap-4 md:flex-row md:items-center md:justify-between">
      <l-text t="body3" flow="block" class="text-gray-700 md:max-w-3xl">
        Utilizamos cookies essenciais para manter sua sessão autenticada e armazenamento local para preferências de
        interface. Saiba mais na
        <l-legal-link slug="cookies">Política de Cookies</l-legal-link>
        e na
        <l-legal-link slug="privacy">Política de Privacidade</l-legal-link>.
      </l-text>
      <button lButton bType="primary" bSize="small" type="button" class="shrink-0" (click)="acknowledge()">Entendi</button>
    </div>
  </div>
}
